import { ROUTES, type RoutePath } from '../lib/routes';
import { navigate } from '../router';
import { showToast } from '../components/toast';
import { el } from '../utils/dom';
import { portalLogin } from '../api/loginPortal';
import { takeLoginNext } from '../lib/portalSession';

function textField(label: string, type: string, placeholder: string): HTMLElement {
  const wrap = el('div', { className: 'ev123-field' });
  const input = el('input', { className: 'ev123-input', type, placeholder }) as HTMLInputElement;
  wrap.append(el('label', { className: 'ev123-label', text: label }), input);
  return wrap;
}

export function renderLoginPage(root: HTMLElement): void {
  const wrap = el('div', {});

  wrap.append(
    el('div', { className: 'ev123-page-head' }, [
      el('div', { className: 'ev123-container' }, [
        el('h1', { className: 'ev123-page-head__title', text: '로그인' }),
        el('p', {
          className: 'ev123-page-head__lead',
          text: '관리자 승인이 완료된 계정만 로그인할 수 있습니다. 가입 직후에는 승인 대기 상태이므로 로그인되지 않을 수 있습니다.',
        }),
      ]),
    ])
  );

  const container = el('div', { className: 'ev123-container' });
  const card = el('div', { className: 'ev123-card' });

  const loginField = textField('아이디', 'text', '가입 시 아이디');
  const passwordField = textField('비밀번호', 'password', '비밀번호');

  card.append(loginField, passwordField);

  const submit = el('button', {
    type: 'button',
    className: 'ev123-btn ev123-btn--primary ev123-btn--block',
    style: 'margin-top:1rem',
  }) as HTMLButtonElement;
  submit.textContent = '로그인';

  const signupRow = el('p', { className: 'ev123-field-hint', style: 'text-align:center;margin-top:1rem' });
  signupRow.append(
    document.createTextNode('아직 계정이 없으신가요? '),
    (() => {
      const a = el('a', { href: ROUTES.signup, 'data-nav': '' }) as HTMLAnchorElement;
      a.textContent = '가입 신청';
      return a;
    })()
  );

  submit.addEventListener('click', async () => {
    const loginIn = loginField.querySelector('input') as HTMLInputElement | null;
    const pwdIn = passwordField.querySelector('input') as HTMLInputElement | null;
    const login = loginIn?.value?.trim() ?? '';
    const password = pwdIn?.value ?? '';
    if (!login || !password) {
      showToast('아이디와 비밀번호를 입력해 주세요.');
      return;
    }
    submit.disabled = true;
    const prev = submit.textContent;
    submit.textContent = '확인 중…';
    try {
      await portalLogin(login, password);
      const next = takeLoginNext();
      navigate((next || ROUTES.myApplications) as RoutePath);
    } catch (e) {
      const msg = e instanceof Error ? e.message : '로그인에 실패했습니다.';
      showToast(msg);
    } finally {
      submit.disabled = false;
      submit.textContent = prev ?? '로그인';
    }
  });

  card.appendChild(submit);
  card.appendChild(signupRow);
  container.appendChild(card);
  wrap.appendChild(container);
  root.appendChild(wrap);
}
